module.exports = __webpack_public_path__ + "img/spade_snap.abceaf33.png";